export const handleKeyDown = (event) => {
  if (event.key === 'Enter') {
    event.preventDefault()
  }
}
